import { render } from "./article-list-hub.vue?vue&type=template&id=77bd9ef5"
import script from "./article-list-hub.vue?vue&type=script&lang=js"
export * from "./article-list-hub.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__